let DIT_URL = "https://www.ifincloud.io";
let SIT_URL = "http://10.160.29.32:8080";
let connectTo = DIT_URL;

export const environment = {
  production: true,
  baseURL: '',
  fileUploadURL: '',
  currencyFormat: 'en-US',
  commonPublisher: '',
  accountsPublisher:'',
  customersPublisher: '',
  cardsPublisher: '',
  depositsPublisher:'',
  loansPublisher:'',
  billpaymentsPublisher:'',
  transfersPublisher:'',
  defaultPublisher: '',
  languageId: ''
};
